import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
import { useTelemetry } from '../internal/hooks/use-telemetry';
export default function Spinner(_a) {
    var _b = _a.size, size = _b === void 0 ? 'normal' : _b, _c = _a.variant, variant = _c === void 0 ? 'normal' : _c, props = __rest(_a, ["size", "variant"]);
    useTelemetry('Spinner');
    var baseProps = getBaseProps(props);
    return (React.createElement("span", __assign({}, baseProps, { className: clsx(baseProps.className, styles.root, styles["size-" + size], styles["variant-" + variant]) }),
        React.createElement("span", { className: clsx(styles.circle, styles['circle-left']) }),
        React.createElement("span", { className: clsx(styles.circle, styles['circle-right']) })));
}
//# sourceMappingURL=index.js.map